var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-chip',{attrs:{"color":"success","outlined":""},on:{"click":function($event){$event.stopPropagation();return (function () {}).apply(null, arguments)}}},[_vm._v(" Seção Default ")])}
var staticRenderFns = []

export { render, staticRenderFns }